const stickyButtonEl = document.querySelector('.sticky-button-el');
const stickyButtonImage = document.querySelector('.sticky-button-image img');
const stickyButtonWrpEl = document.getElementById('sticky-button-wrp');
const stickyButtonPriceEl = document.querySelector('.sticky-button-price');
const stickyButtonQuantityEl = document.querySelector('.sticky-button-product-units-quanrity');
const stickyButtonItemsCountEl = document.querySelector('.sticky-button-items-count');
const discountBadgeEl = document.getElementById('sticky-button-discount-badge');
const bulkImageQuantityWrp = document.querySelector('.sticky-button-image-quantity-wrp');
const stickyButtonPriceOldEl = document.querySelector('.sticky-button-price-old');
const basePrice = document.querySelector('.product-quantity-bulk-item-price').dataset.basePrice;
const bodyEl = document.body;
const stickyNativeControls = document.querySelectorAll('.product-item-add-to-cart:not(.sticky-button-el), .product-quantity-retail');

const SCROLL_HIDE_DELAY = 350;
let lastScrollTs = 0;
let scrollHideTimer = null;

function setStickyButtonVisibility(shouldShow) {
  if (shouldShow) {
    stickyButtonWrpEl.classList.add('active');
    bodyEl.classList.add('sticky-button-active');
    return;
  }

  stickyButtonWrpEl.classList.remove('active');
  bodyEl.classList.remove('sticky-button-active');
}

function isElementInViewport(element) {
  if (!element || !element.getBoundingClientRect) {
    return false;
  }

  if (window.getComputedStyle(element).display === 'none') {
    return false;
  }

  const rect = element.getBoundingClientRect();
  return rect.bottom > 0 && rect.top < window.innerHeight;
}

function isAnyNativeOrderButtonVisible() {
  if (!stickyNativeControls || stickyNativeControls.length === 0) {
    return false;
  }

  return Array.from(stickyNativeControls).some((control) => {
    if (!control.offsetParent && window.getComputedStyle(control).position !== 'fixed') {
      return false;
    }

    return isElementInViewport(control);
  });
}

function shouldHideWhileScrolling() {
  return Date.now() - lastScrollTs < SCROLL_HIDE_DELAY;
}

function shouldShowStickyButton() {
  const isMobileViewport = window.matchMedia('(max-width: 991px)').matches;
  const passedFirstScreen = isMobileViewport || window.scrollY >= window.innerHeight;
  if (!passedFirstScreen) {
    return false;
  }

  if (isAnyNativeOrderButtonVisible()) {
    return false;
  }

  if (shouldHideWhileScrolling()) {
    return false;
  }

  return true;
}

function updateStickyButtonState() {
  if (!stickyButtonWrpEl) {
    return;
  }

  setStickyButtonVisibility(shouldShowStickyButton());
}

function handleScroll() {
  lastScrollTs = Date.now();
  updateStickyButtonState();

  clearTimeout(scrollHideTimer);
  scrollHideTimer = setTimeout(updateStickyButtonState, SCROLL_HIDE_DELAY + 20);
}

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', updateStickyButtonState);
  updateStickyButtonState();
  stickyButtonWrpEl.addEventListener('click', (e) => {
    const bundleSection = document.getElementById('product-quantity-selection');

    if (!bundleSection) {
      window.scrollTo(0, 0);
      return;
    }

    const targetTop = window.scrollY + bundleSection.getBoundingClientRect().top - 200;

    window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
  });

  let curActiveVariation = document.querySelector('.product-quantity-retail-item.active');
  setStickyButton(curActiveVariation);
});

function setStickyButton(item) {
  let priceItem = item.querySelector('.product-quantity-retail-item-price');
  let priceText = '';
  if (priceItem) {
    priceText = priceItem.textContent;
  } else {
    priceText = item.querySelector('.product-quantity-retail-item-price-promotional').textContent;
  }
  let quantity = item.dataset.productQuantity;
  const parsedQuantity = parseInt(quantity, 10) || 1;
  stickyButtonPriceEl.textContent = priceText;
  if (parsedQuantity > 1) {
    stickyButtonEl.classList.add('two-or-more-items');
    if (stickyButtonWrpEl) {
      stickyButtonWrpEl.classList.add('has-multiple-items');
    }
    stickyButtonPriceOldEl.textContent = currencySymbol + basePrice * parsedQuantity;
    stickyButtonPriceOldEl.style.display = 'block';
  } else {
    stickyButtonEl.classList.remove('two-or-more-items');
    if (stickyButtonWrpEl) {
      stickyButtonWrpEl.classList.remove('has-multiple-items');
    }
    stickyButtonPriceOldEl.textContent = '';
    stickyButtonPriceOldEl.style.display = 'none';
  }

  if (stickyButtonQuantityEl) {
    stickyButtonQuantityEl.textContent = parsedQuantity;
  }
  if (stickyButtonItemsCountEl) {
    stickyButtonItemsCountEl.textContent = parsedQuantity;
  }
  let discount = productDiscountAmounts[parsedQuantity];
  discountBadgeEl.textContent = '-' + discount + '%';
  if (discount > 0) {
    discountBadgeEl.classList.remove('hidden');
  } else {
    discountBadgeEl.classList.add('hidden');
  }
  // set image
  let productImageSrc = item.querySelector('.product-quantity-retail-item-image img').src;
  changeProductImage(stickyButtonImage, productImageSrc);
}

function setStickyButtonMode(mode) {
  if (mode == 'retail') {
    let curActiveVariation = document.querySelector('.product-quantity-retail-item.active');
    setStickyButton(curActiveVariation);
    if (bulkImageQuantityWrp) {
      bulkImageQuantityWrp.classList.remove('active');
    }
  } else {
    setStickyButtonBulk();
    if (bulkImageQuantityWrp) {
      bulkImageQuantityWrp.classList.add('active');
    }
  }
}

function setStickyButtonBulk() {
  let productBulkPrice = document.querySelector('.product-quantity-bulk-item-price').textContent;
  //let currencySymbol = document.querySelector('.product-quantity-bulk-unit-price-currency-symbol').textContent;
  let productQuantityBulk = document.querySelector('.product-quantity-bulk-units-qt').textContent;
  stickyButtonPriceEl.textContent = currencySymbol + productBulkPrice.trim();
  if (stickyButtonQuantityEl) {
    stickyButtonQuantityEl.textContent = productQuantityBulk;
  }

  let quantity = parseInt(productQuantityBulk);
  if (quantity > 1) {
    stickyButtonEl.classList.add('two-or-more-items');
    if (stickyButtonWrpEl) {
      stickyButtonWrpEl.classList.add('has-multiple-items');
    }
  } else {
    stickyButtonEl.classList.remove('two-or-more-items');
    if (stickyButtonWrpEl) {
      stickyButtonWrpEl.classList.remove('has-multiple-items');
    }
  }
  if (stickyButtonItemsCountEl) {
    stickyButtonItemsCountEl.textContent = quantity;
  }
  let discount = productDiscountAmounts[quantity];
  discountBadgeEl.textContent = '-' + discount + '%';
  discountBadgeEl.classList.remove('hidden');

  stickyButtonPriceOldEl.textContent = currencySymbol + basePrice * quantity;
  stickyButtonPriceOldEl.style.display = 'block';

  if (bulkImageQuantityWrp) {
    var colors = [];
    var colorsAll = '';
    var qt = 0;
    let quantityBulkInputs = document.querySelectorAll('.product-quantity-bulk-input');
    let stickyButtonImageQuantityMarkers = document.querySelectorAll('.sticky-button-image-quantity');
    quantityBulkInputs.forEach((input, index) => {
      let colorQt = input.value;
      let color = input.dataset.color;
      let label = stickyButtonImageQuantityMarkers[index];
      if (colorQt != 0) {
        colors.push(color);
        qt++;
        if (label) {
          label.innerHTML = 'x' + colorQt;
          label.classList.add('active');
        }
      } else {
        label.classList.remove('active');
      }
    });
    if (colors.length != 0) {
      colorsAll = colors.sort().join('-');
      let productHandle = 'product-luminette-3';
      let img_url = getImageUrl(productHandle + '-' + colorsAll + '-qt-' + qt + '-2x');
      changeProductImage(stickyButtonImage, img_url);
    }
  }
}

function setStickyButtonImage(img_url) {
  changeProductImage(stickyButtonImage, img_url);
}
